import AddPripomienkaPage from './AddPripomienkaPage';

export default AddPripomienkaPage;
